import React from "react";
import { render } from "react-dom";
import CountDown from "../widgets/CountDown";

let countDownElem = document.querySelectorAll(".widget-countdown");
if (countDownElem.length) {
    countDownElem.forEach(elem => {
        render(<CountDown initialCountDown={$(elem).data('countdown')} />, elem);
    });
}